import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const purchases = [['Giulia F.', 'Torino', 'PILATES PRONTA™ — Pacchetto completo'], ['Martina R.', 'Milano', 'PILATES PRONTA™ — Pacchetto completo'], ['Elena B.', 'Roma', 'PILATES PRONTA™ — Pacchetto completo'], ['Laura C.', 'Bologna', 'PILATES PRONTA™ — Pacchetto completo']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    let cycleTimer: number | undefined;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-24 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-transform duration-300 ease-out sm:bottom-28 ${visible ? 'translate-x-0' : '-translate-x-[120%]'}`} data-id="element-238" data-mp="1fxmzdr8b00fd">
      <div className="relative rounded-2xl border border-emerald-950/10 bg-white p-4 pr-10 shadow-2xl" data-id="element-239" data-mp="i8a6337a987t">
        <button type="button" aria-label="Chiudi la notifica di acquisto recente" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-slate-500 hover:text-[#241322]" data-id="element-240" data-mp="x51ajqvtda4a">
          <XIcon className="h-4 w-4" data-id="element-241" data-mp="28k7qqros4cix" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-emerald-800" data-id="element-242" data-mp="28iwncsz8x6sc">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-emerald-500" data-id="element-243" data-mp="23nh9w255hcwg">
            <CheckIcon className="h-3 w-3 text-white" data-id="element-244" data-mp="2aobg6ud8gczo" />
          </span>
          Acquisto verificato
        </p>
        <p className="mt-3 text-sm font-semibold text-[#241322]" data-id="element-245" data-mp="2fpqxcbcahzcs">
          <strong data-id="element-246" data-mp="2ko29isq24ly6">{purchase[0]}</strong> da {purchase[1]}
        </p>
        <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-247" data-mp="2pmdjr4k9kygx">
          ha appena acquistato{' '}
          <span className="font-bold text-emerald-800" data-id="element-248" data-mp="1rylinzi35d42">{purchase[2]}</span>
        </p>
      </div>
    </aside>;
}